import { jsx } from "react/jsx-runtime";
import { InputNumber } from "antd";
import { forwardRef } from "react";
import { DownOutlined, UpOutlined } from "@wepie/weet-icons";
import classnames from "classnames";
import { rootClass } from "./constant.js";
import "./styles.css";
const input_number_InputNumber = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { controls, className, ...rest } = props;
    return /*#__PURE__*/ jsx(InputNumber, {
        ref: ref,
        ...rest,
        className: classnames(rootClass, className),
        controls: getControlsProp(controls)
    });
});
const DefaultControls = {
    upIcon: /*#__PURE__*/ jsx(UpOutlined, {}),
    downIcon: /*#__PURE__*/ jsx(DownOutlined, {})
};
const getControlsProp = (input)=>{
    if (true === input || void 0 === input) return DefaultControls;
    return input;
};
export { input_number_InputNumber as InputNumber };
